import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/sos-logo.png'


const _hoisted_1 = { class: "logging-bg flex h-screen w-screen p-4" }
const _hoisted_2 = { class: "flex flex-col-reverse md:flex-row shadow-xl rounded-lg m-auto overflow-hidden" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-extralight my-1 mb-2" }, " Para comenzar, inicia sesión con tu correo registrado en la plataforma de Beepi. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-extralight my-1 mb-2" }, " Si tienes algún problema con tu registro ponte en contacto con nosotros al correo contacto@beepi.cl ", -1)
const _hoisted_5 = { class: "bg-white py-4 px-10 md:w-72 flex flex-col gap-2 items-center justify-center" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = {
  key: 0,
  class: "text-red-600 text-sm mb-4"
}
const _hoisted_8 = {
  key: 2,
  class: "flex items-center justify-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-primary-500 border-success" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "bg-black bg-opacity-60 p-4 md:w-72 flex flex-col justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "flex",
    src: _imports_0,
    alt: "logo beepi"
  })
], -1)

import { ref } from "vue";
import { useRouter } from "vue-router";
import { AuthService } from "@/services/auth/AuthServices";
import { useAuthStore } from "@/stores/auth";
import { CommunityService } from "@/services/communities/CommunityServices";

import { swal as Swal } from "@/configs/swal";

import TextField from "@/components/general/atoms/TextField.vue";
import RecoverAccount from "@/components/communities/molecules/RecoverAccount.vue";
import AppButton from "@/components/general/atoms/AppButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const communityService = new CommunityService();
const router = useRouter();
const authService = new AuthService();
const authStore = useAuthStore();
const email = ref("");
const password = ref("");
const hasError = ref(false);
const showPassword = ref(false);
const loading = ref(false);
const errorMessage = ref("Credenciales inválidas");
const recoverPassword = ref(false);

function showPass() {
  showPassword.value = !showPassword.value;
}

async function login() {
  hasError.value = false;
  loading.value = true;
  const response = await authService.login(email.value, password.value);
  loading.value = false;
  if (!response.success) {
    hasError.value = true;

    if (response?.message) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message,
      });
    }

    return;
  } else {
    authStore.setToken(response.data.token);
    authStore.setUserSession(response.data);
    const communities = await communityService.getCommunitiesUser();
    if (communities.data.length != 0) {
      if (communities.data.length === 1) {
        const communityUser = await communityService.getComunityUser(
          communities.data[0].id,
          response.data.userId
        );

        authStore.setCommunityUser(communityUser.data);
        const comunnityBlocksUser = await communityService.getCommunityBlocks(
          communityUser.data.communityId,
          communityUser.data.id
        );
        authStore.setBlockUser(comunnityBlocksUser?.data[0]);
        if (comunnityBlocksUser.data.length > 0) {
          return comunnityBlocksUser.data.length === 1
            ? router.push({
                name: "home",
                params: {
                  id: comunnityBlocksUser.data[0].id,
                  community: communities.data[0].id,
                },
              })
            : router.push("block-list");
        } else {
          return router.push({
            name: "home",
            params: { id: 0, community: communities.data[0].id },
          });
        }
      } else {
        return router.push("block-list");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Este usuario no tiene una comunidad asociada",
      });
    }
  }
}

function showRecoverPasswordModal() {
  recoverPassword.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "bg-black bg-opacity-60 p-4 md:w-72 flex flex-col" }, [
        _hoisted_3,
        _createElementVNode("p", { class: "text-white font-extralight my-1 mb-2" }, [
          _createTextVNode(" Para crear o recuperar tu contraseña, por favor haz click en el siguiente enlace: "),
          _createElementVNode("button", {
            class: "font-semibold underline underline-offset-4 hover:text-primary-300 inline p-0 align-baseline bg-transparent border-none cursor-pointer text-white mt-2 block",
            onClick: showRecoverPasswordModal
          }, " Crear o recuperar contraseña ")
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextField, {
          label: "Correo electrónico",
          model: email.value,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          type: "text",
          name: "email",
          "hide-details": "",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (login()), ["enter"])),
          class: "mb-2"
        }, null, 8, ["model"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextField, {
            label: "Contraseña",
            model: password.value,
            "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
            type: showPassword.value ? 'text' : 'password',
            name: "password",
            "hide-details": "",
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (login()), ["enter"]))
          }, null, 8, ["model", "type"]),
          _createElementVNode("button", {
            class: "absolute right-2 top-8 rounded-lg bg-primary-600 hover:bg-primary-800 font-bold mx-auto",
            onClick: showPass
          }, [
            (showPassword.value)
              ? (_openBlock(), _createBlock(_component_mdicon, {
                  key: 0,
                  name: "eye",
                  size: "20"
                }))
              : _createCommentVNode("", true),
            (!showPassword.value)
              ? (_openBlock(), _createBlock(_component_mdicon, {
                  key: 1,
                  name: "eye-remove-outline",
                  size: "20"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        (hasError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        (!loading.value)
          ? (_openBlock(), _createBlock(AppButton, {
              key: 1,
              text: "Iniciar Sesión",
              uppercase: true,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (login())),
              class: "bg-green-500 text-white mt-4"
            }))
          : _createCommentVNode("", true),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _hoisted_11
    ]),
    _createVNode(RecoverAccount, {
      visible: recoverPassword.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((recoverPassword).value = $event))
    }, null, 8, ["visible"])
  ]))
}
}

})